import { RECOMMENDATIONS_ACTIONS, RECOMMENDATIONS_DATA_FETCHER_ACTIONS } from '../../actions/recommendationsActions';

import { LIKE, WHOLE_HOME, SELECT_ALL } from '../../constants/common';

let recoTipsToSaveEnergy = null;

const recommendationReducer = (state ={
    recoTop5Data: null,
    recoTipsToSaveEnergyList: null,
    recoPrograms: null,
    recoTipsToSaveEnergy: null,
    recoFilterDropdownEl: null,
    recoDropdownCheckboxAppliances: null,
    recoNumberOfItems: 6,
    isLoading: false,
    unviewedRecos: null,
    recoDetails : null,
    recoMeta : null,
    fetchingDetails : false,
    recoDetailsError : false,
    queryRecoCardLoaded : false,
    selectedAppliances : [],
    allowedAppliances : []
}, action) => {
    switch(action.type) {
        case RECOMMENDATIONS_ACTIONS.SET_DROPDOWN_VALUES: {
            
            let recoCheckboxAppliances = {};
            state.allowedAppliances.map(item => {
                recoCheckboxAppliances[item] = false
            });
            recoCheckboxAppliances[SELECT_ALL] = false;
            recoCheckboxAppliances[WHOLE_HOME] = false;
            
            let selectedAppliances = state.selectedAppliances.concat(action.payload);
            if(selectedAppliances.length > 1){
                selectedAppliances = action.payload;
                recoCheckboxAppliances = {
                    [SELECT_ALL]: true,
                    [WHOLE_HOME]: true
                };
            }
            
            
            selectedAppliances.map(item => {
                recoCheckboxAppliances[item] = true
            });
            state = {
                ...state,
                recoDropdownCheckboxAppliances: recoCheckboxAppliances,
                selectedAppliances : selectedAppliances
            }
            break;
        }
        case RECOMMENDATIONS_DATA_FETCHER_ACTIONS.SET_UNREAD_RECOS: {
            state = {
                ...state,
                unviewedRecos: action.payload ? action.payload[0].unviewedRecommendationsSize : (state.unviewedRecos - 1)
            };
            break;
        }
        case RECOMMENDATIONS_DATA_FETCHER_ACTIONS.FETCH_RECO_TOP_5: 
            state = {
                ...state,
                recoTop5Data: action.payload
            }
            break;
        case RECOMMENDATIONS_DATA_FETCHER_ACTIONS.FETCH_RECO_PROGRAMS: 
            state = {
                ...state,
                recoPrograms: action.payload
            };
            break;
        case RECOMMENDATIONS_DATA_FETCHER_ACTIONS.FETCH_TIPS_TO_SAVE_ENERGY: 
            state = {
                ...state,
                recoTipsToSaveEnergyList: action.payload,
                recoTipsToSaveEnergy: action.payload.slice(0, state.recoNumberOfItems),
                isLoading: false
            }
            break;
        case RECOMMENDATIONS_ACTIONS.RECO_TOGGLE_FILTER_DROPDOWN: 
            state = {
                ...state,
                ...action.payload
            }
            break;
        case RECOMMENDATIONS_ACTIONS.RECO_TOGGLE_DROPDOWN_APPLIANCES_CHECKBOX: 
            let recoDropdownCheckboxAppliances = {
                ...state.recoDropdownCheckboxAppliances,
                [action.payload]: !state.recoDropdownCheckboxAppliances[action.payload]
            };
            let checkIfAllSelected = true, keys = Object.keys(recoDropdownCheckboxAppliances);

            for (let i = 0; i < keys.length; i++) {
                if (keys[i] !== SELECT_ALL && recoDropdownCheckboxAppliances[keys[i]] === false) {
                    checkIfAllSelected = false;
                    break;
                }
            }

            state = {
                ...state,
                recoDropdownCheckboxAppliances: {
                    ...recoDropdownCheckboxAppliances,
                    [SELECT_ALL]: checkIfAllSelected
                }
            }
            break;
        case RECOMMENDATIONS_ACTIONS.RECO_TOGGLE_DROPDOWN_APPLIANCES_CHECKBOX_ALL: 
            let valueToSet = !state.recoDropdownCheckboxAppliances[SELECT_ALL];
            let recoDropdownCheckBoxes = {
                [SELECT_ALL]: valueToSet,
                [WHOLE_HOME]: valueToSet
            };
            state.allowedAppliances.map(item => {
                recoDropdownCheckBoxes[item] = valueToSet
            });
            state = {
                ...state,
                recoDropdownCheckboxAppliances: recoDropdownCheckBoxes
            };
            break;
        case RECOMMENDATIONS_ACTIONS.RECO_SHOW_LOADER: 
            state = {
                ...state,
                isLoading: true
            };
            break;
        case RECOMMENDATIONS_ACTIONS.RECO_SHOW_MORE: 
            state = {
                ...state,
                recoNumberOfItems: state.recoNumberOfItems + 6,
                recoTipsToSaveEnergy: state.recoTipsToSaveEnergyList.slice(0, state.recoNumberOfItems + 6),
            };
            break;
        case RECOMMENDATIONS_DATA_FETCHER_ACTIONS.ON_RECO_LIKE: 
            recoTipsToSaveEnergy = state.recoTipsToSaveEnergy;
            if (recoTipsToSaveEnergy[action.payload].recommendationFeedback.response === LIKE) {
                break;
            }
            recoTipsToSaveEnergy[action.payload].recommendationFeedback.response = LIKE;
            recoTipsToSaveEnergy[action.payload].recommendationStatistics.countLike++;
            delete recoTipsToSaveEnergy[action.payload]["updatingLikes"];
            state = {
                ...state,
                recoTipsToSaveEnergy: recoTipsToSaveEnergy
            };
            break;
        case RECOMMENDATIONS_DATA_FETCHER_ACTIONS.ON_RECO_UNLIKE: 
            recoTipsToSaveEnergy = state.recoTipsToSaveEnergy;
            if (recoTipsToSaveEnergy[action.payload].recommendationFeedback.response === null ) {
                break;
            }
            recoTipsToSaveEnergy[action.payload].recommendationFeedback.response = null;
            recoTipsToSaveEnergy[action.payload].recommendationStatistics.countLike--;
            delete recoTipsToSaveEnergy[action.payload]["updatingLikes"];

            state = {
                ...state,
                recoTipsToSaveEnergy: recoTipsToSaveEnergy
            };
            break;
        case RECOMMENDATIONS_ACTIONS.RESET_DATA: 
            state = {
                recoTipsToSaveEnergy: null,
                recoTop5Data: null,
                recoPrograms: null,
                recoFilterDropdownEl: null,
                recoDropdownCheckboxAppliances: null,
                 selectedAppliances : [],
                 allowedAppliances : []
            };
            break;
        case RECOMMENDATIONS_ACTIONS.ON_UNSELECT_ALL_RECOS_DROPDOWN: 
            state = {
                ...state,
                recoTipsToSaveEnergy: [],
                recoTipsToSaveEnergyList: [],
                isLoading: false
            };
            break;
        case RECOMMENDATIONS_DATA_FETCHER_ACTIONS.FETCH_RECO_DETAILS:
            state = {
                ...state,
                recoDetails : {
                    ...state.recoDetails,
                    [action.payload.recoId] : action.payload.details ? action.payload.details : {unAvailable : true}
                },
                recoMeta : {
                    ...state.recoMeta,
                    [action.payload.recoId] : action.payload.metaData
                },
                fetchingDetails : false
            }
            break;
        case RECOMMENDATIONS_DATA_FETCHER_ACTIONS.FETCH_RECO_DETAILS_FAILURE: 
            state = {
                ...state,
                recoDetails : {
                    ...state.recoDetails,
                    [action.payload.recoId] : {unAvailable : true}
                },
                fetchingDetails : false
            }
            break;
        case RECOMMENDATIONS_ACTIONS.FETCHING_DETAILS : {
            state = {
                ...state,
                fetchingDetails : true
            }
            break;
        }
        case RECOMMENDATIONS_ACTIONS.QUERY_RECO_CARD_LOADED : {
            state = {
                ...state,
                queryRecoCardLoaded : true
            }
            break;
        }
        case RECOMMENDATIONS_DATA_FETCHER_ACTIONS.UPDATING_LIKES : {
            recoTipsToSaveEnergy = state.recoTipsToSaveEnergy;	
            recoTipsToSaveEnergy[action.payload].updatingLikes = true;
            state = {
                ...state,
                recoTipsToSaveEnergy
            }
            break;
        }
        case RECOMMENDATIONS_ACTIONS.SET_ALLOWED_APPLIANCES : {
            state = {
                ...state,
                allowedAppliances : action.payload
            }
            break;
        }
        default:
            break;
    }
    return state;
}

export default recommendationReducer